import apiClient from './apiClient';

export interface DashboardStats {
  accounts: {
    total: number;
    active: number;
    tier1: number;
    tier2: number;
    buyer?: number;
    partner?: number;
  };
  contacts: {
    total: number;
    decisionMakers: number;
  };
  callLogs: {
    total: number;
    thisWeek: number;
  };
  callTasks: {
    total: number;
    pending: number;
    completed: number;
  };
  mqls: {
    total: number;
  };
}

/**
 * Get dashboard statistics
 */
export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await apiClient.get<DashboardStats>('/api/dashboard/stats');
  return response.data;
};

export interface NameValue { name: string; value: number; }

export interface DashboardAnalytics {
  range: { from: string; to: string };
  totals: {
    accounts: number;
    buyerAccounts?: number;
    partnerAccounts?: number;
    mqlSubmitted: number;
    mqlAccepted: number;
    qualifiedMql: number;
    qualifiedPql?: number;
    journeysActive: number;
    journeysCompleted: number;
  };
  journeysByType?: {
    buyer: { active: number; completed: number };
    partner: { active: number; completed: number };
  };
  byType?: NameValue[];
  byIndustry: NameValue[];
  byRegion: NameValue[];
  byPlant: NameValue[];
  byTier: NameValue[];
  byStatus: NameValue[];
  byPainAxis: NameValue[];
  byMaturity: NameValue[];
  industryByTier: Array<{ name: string; Tier1: number; Tier2: number; Tier3: number; total: number }>;
  regionByPain: Array<Record<string, any>>;
  readinessData: NameValue[];
  mqlTrend: Array<{ date: string; submitted: number; accepted: number }>;
  funnel: Array<{ stage: string; count: number }>;
  callTrend: Array<{ date: string; count: number }>;
}

export const getDashboardAnalytics = async (from?: string, to?: string): Promise<DashboardAnalytics> => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const response = await apiClient.get<DashboardAnalytics>(`/api/dashboard/analytics?${params}`);
  return response.data;
};
